export default "__VITE_ASSET__fa024c06__"